import React, { useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { Header } from '../../../components/singleComponents/headers';
import { MainTable } from '../../../components/singleComponents/tables/Table/MainTable';

import api, { authHeader } from '../../../../services/API/apiConfig';
import {
  BackgroundIconStyled,
  BtnStyled,
  ButtonInputStyled,
  ContentStyled,
  IconStyled,
  MiddleOfThePageStyled,
  RootStyled,
  SearchAndFilterStyled,
  TextFieldStyled,
  TextStyled,
} from './ClientAdmin.styles';

export function ClientAdmin() {
  const navigate = useNavigate();

  const [clients, setClients] = useState([]);
  const [filteredClient, setFilteredClient] = useState();
  const [searchTerm, setSearchTerm] = useState('');

  const tableHead = ['Nome', 'Endereço', 'Email', 'Telefone'];
  const row = ['name', 'address', 'email', 'phone'];

  const goToNewClient = () => {
    navigate('/new-client');
  };

  const editUser = (userData) => {
    if (!userData) return;
    navigate(`/new-client/${userData.id}`);
  };

  useEffect(() => {
    const getClients = () => {
      api
        .get('/users', {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setClients(
            data.map((c) => {
              if (c.phone && c.cellphone) {
                return {
                  ...c,
                  phone: `${c.phone} / ${c.cellphone}`,
                };
              }
              if (!c.phone && c.cellphone) {
                return {
                  ...c,
                  phone: `${c.cellphone}`,
                };
              }
              return c;
            })
          );
        });
    };
    if (searchTerm === '') {
      setFilteredClient();
      getClients();
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm !== '') {
      setFilteredClient(
        clients.filter(
          (data) =>
            data.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.address?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.phone?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm]);

  return (
    <>
      <Header page="Clientes" />
      <RootStyled>
        <MiddleOfThePageStyled>
          <BtnStyled
            color="secondary"
            variant="contained"
            onClick={goToNewClient}
          >
            Cadastrar cliente
          </BtnStyled>
          <SearchAndFilterStyled>
            <dSearchStyled>
              <TextFieldStyled
                type="search"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <ButtonInputStyled variant="contained">
                <MdSearch size={17} />
              </ButtonInputStyled>
            </dSearchStyled>
          </SearchAndFilterStyled>
        </MiddleOfThePageStyled>
        <ContentStyled>
          {clients.length !== 0 ? (
            <MainTable
              data={filteredClient || clients}
              headings={tableHead}
              keys={row}
              callbackClickRow={editUser}
            />
          ) : (
            <BackgroundIconStyled>
              <IconStyled size={174} />
              <TextStyled variant="h4">
                Nenhum cliente cadastrado até o momento.
              </TextStyled>
            </BackgroundIconStyled>
          )}
        </ContentStyled>
      </RootStyled>
    </>
  );
}
